import { ActionContext } from 'vuex'
import apiAdminRole from '@/api/admin/role'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IRoleState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbRole } from '@/models/alodb/AloDbRole';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class RoleAction {
   
  public [types.ROLE_REQUEST](context: ActionContext<IRoleState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.ROLE_REQUEST)
        apiAdminRole
          .getRoles()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const roleArray = resp.data.data as AloBaseArray<AloDbRole>
              context.commit(types.ROLE_SUCCESS, roleArray.items)
              resolve(roleArray.items)
            } else {
              context.commit(types.ROLE_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.ROLE_ERROR)
            reject()
          })
      })
  }

  public [types.ROLE_ENSURE_LIST](context: ActionContext<IRoleState, IRootState>) {
    if(context.state.roles.length == 0) {
        return context.dispatch(types.ROLE_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.roles)            
        })
    }    
  }

  public [types.ROLE_SELECT_DETAIL](context: ActionContext<IRoleState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const role = context.getters.rolesById[itemId] as AloDbRole      
      if(role) {        
        if(role.detailLoaded) {
          context.commit(types.ROLE_SELECT_DETAIL,role)
          resolve(role)
        }
        else{
          context.dispatch(types.ROLE_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.ROLE_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newRole = new AloDbRole()
        context.commit(types.ROLE_SELECT_DETAIL,newRole)
        resolve(newRole)
      }
    })
  }

  public [types.ROLE_SELECT_DETAIL_REQUEST](context: ActionContext<IRoleState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.ROLE_SELECT_DETAIL_REQUEST, itemId)
        apiAdminRole
          .getRole(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const role = resp.data.data as AloDbRole
              context.commit(types.ROLE_SELECT_DETAIL_SUCCESS, role)
              context.commit(types.ROLE_SELECT_DETAIL,role)
              resolve(role)
            } else {
              context.commit(types.ROLE_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.ROLE_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.ROLE_SAVE_REQUEST](context: ActionContext<IRoleState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmRole.id
        context.commit(types.ROLE_SAVE_REQUEST,context.state.modifiedAdmRole.ROL_LIBELLE)
        apiAdminRole
          .saveRole(context.state.modifiedAdmRole)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const role = resp.data.data as AloDbRole            
              context.commit(types.ROLE_SELECT_DETAIL_SUCCESS, role)
              context.commit(types.ROLE_SELECT_DETAIL,role)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:role.ROL_LIBELLE}))
              if(tryRedirect && router.app.$route.name === 'NewRole') router.push({name:'EditRole',params:{roleid:role.id!.toString()}})
              resolve(role)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.ROLE_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.ROLE_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.ROLE_UPDATE_MODIFIED_ADM](context: ActionContext<IRoleState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.ROLE_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmRole)
    })
  }
  
  public [types.ROLE_CANCEL_MODIFIED_ADM](context: ActionContext<IRoleState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.ROLE_SELECT_DETAIL,context.state.originalAdmRole)
      resolve(context.state.modifiedAdmRole)
    })
  }

  public [types.ROLE_UPDATE_FILTER_ADM](context: ActionContext<IRoleState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.ROLE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
  
  
}

export default util.classToObject(RoleAction)